import React, { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../Generalfiles/CSS_GENERAL/bootstrap.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import tabexlogo from '../Generalfiles/images/tabexlogo.png';
import egyptflag from '../Generalfiles/images/egyptflag.png';
import usflag from '../Generalfiles/images/usflag.png';
import Dropdown from 'react-bootstrap/Dropdown';
import { BiSupport } from 'react-icons/bi';
import noimage from '../Generalfiles/images/noimage.png';
import { CgMenuLeftAlt, CgMenuRightAlt } from 'react-icons/cg';
import { LanguageContext } from '../../../LanguageContext';
import { Loggedincontext } from '../../../Loggedincontext.js';
import { Routedispatcher } from '../../../Routedispatcher.js';
import headerstyles from './header.module.css';
import '../Generalfiles/CSS_GENERAL/dropdown.css';
import { Contexthandlerscontext } from '../../../Contexthandlerscontext.js';
import { logout } from '../../API/Login_API';
import { useMutation } from 'react-query';
import { NotificationManager } from 'react-notifications';
import sidenavstyles from '../Sidenavfiles/sidenav.module.css';
import { imagebaselink } from '../../../Env_Variables';
import { getDailyMotivationalQuote } from './motivationalQuotes';

const Header = () => {
    let history = useHistory();
    const { lang, setlang, langdetect } = React.useContext(LanguageContext);
    const { userloggedinfobjcontext } = React.useContext(Loggedincontext);
    const { routedispatchercontext } = React.useContext(Routedispatcher);
    const { pagetitle_context } = React.useContext(Contexthandlerscontext);
    let location = useLocation();

    const userName = userloggedinfobjcontext?.userinfo?.name || '';
    const userKey = userloggedinfobjcontext?.userinfo?.userid || userloggedinfobjcontext?.userinfo?.id || '';

    const motivation = useMemo(() => {
        const quote = getDailyMotivationalQuote({
            lang: langdetect === 'en' ? 'en' : 'ar',
            name: userName,
            userKey: String(userKey || userName || 'guest'),
        });
        // Highlight the name inside the sentence for design emphasis
        if (!userName) return { ...quote, nodes: quote.text };
        const parts = quote.text.split(userName);
        if (parts.length === 1) return { ...quote, nodes: quote.text };
        const nodes = [];
        parts.forEach((part, idx) => {
            nodes.push(part);
            if (idx < parts.length - 1) {
                nodes.push(
                    <span key={`name-${idx}`} className={headerstyles.motivation_name}>
                        {userName}
                    </span>,
                );
            }
        });
        return { ...quote, nodes };
    }, [langdetect, userName, userKey]);

    useEffect(() => {
        if (userloggedinfobjcontext?.currentinstinfo?.subscriptiondetails?.isinstactive != undefined) {
            if (
                location.pathname == '/dashboard/institute/subscription' ||
                location.pathname == '/dashboard/institute/upgradingsubscription' ||
                location.pathname == '/dashboard/institute/paymentresponse' ||
                location.pathname == '/dashboard/institute/generalsettings' ||
                location.pathname == '/dashboard/welcome'
            ) {
            } else {
                if (userloggedinfobjcontext?.currentinstinfo?.subscriptiondetails?.isinstactive != true) {
                    history.push('/dashboard/institute/subscription');
                }
            }
        }
    }, [location, userloggedinfobjcontext]);

    const LogoutMutation = useMutation('logout', {
        mutationFn: logout,
        onMutate: () => {},
        onError: () => {
            NotificationManager.error('Error', lang.errorinloggingout);
        },
        onSuccess: () => {
            window.location.href = '/';
        },
    });

    const toggleLanguage = () => {
        if (langdetect == 'en') {
            setlang('ar');
        } else {
            setlang('en');
        }
        window.location.reload();
    };

    const languageToggle = (
        <a className={`${headerstyles.header_menu_item} ${headerstyles.language_cont}`} onClick={toggleLanguage}>
            {langdetect == 'en' ? (
                <span className="text-secondaryhovercontainer d-flex align-items-center">
                    <img src={egyptflag} alt="" />
                    <span className="text-capitalize font-weight-600 font_12">ع</span>
                </span>
            ) : (
                <span className="text-secondaryhovercontainer d-flex align-items-center">
                    <img src={usflag} alt="" />
                    <span className="text-capitalize font-weight-600 font_12">en</span>
                </span>
            )}
        </a>
    );

    const motivationBanner = (
        <div
            className={headerstyles.motivation_banner}
            title={motivation.text}
            dir={langdetect === 'en' ? 'ltr' : 'rtl'}
        >
            <span className={headerstyles.motivation_mark} aria-hidden="true">
                ✦
            </span>
            <div className={headerstyles.motivation_body}>
                <p className={headerstyles.motivation_kicker}>
                    {langdetect === 'en' ? 'For you today' : 'لك اليوم'}
                </p>
                <p className={headerstyles.motivation_text}>{motivation.nodes}</p>
            </div>
        </div>
    );

    return (
        <div className={`${headerstyles.header_shell} row m-0 w-100`}>
            {/* Desktop header */}
            <div className={`${headerstyles.header_container} d-none d-lg-flex`}>
                <div className={headerstyles.header_inner}>
                    <div className={headerstyles.header_left}>
                        <div className={headerstyles.widget_heading}>
                            <span className={headerstyles.widget_username}>{pagetitle_context}</span>
                        </div>
                    </div>

                    <div className={headerstyles.header_right}>
                        <ul className={headerstyles.header_menu}>
                            <button
                                type="button"
                                onClick={() => history.push('/dashboard/institute/support?type=tickets')}
                                className={headerstyles.support_btn}
                            >
                                <BiSupport />
                                <span>{lang.support}</span>
                            </button>

                            <li>
                                <Dropdown>
                                    <Dropdown.Toggle>
                                        <div className={headerstyles.user_chip}>
                                            <div className={headerstyles.widget_heading_sidenav}>
                                                <span className={headerstyles.widgetheading_greeting_sidenav}>
                                                    {lang.hello}
                                                    {langdetect == 'en' ? ',' : '،'}
                                                </span>
                                                <p className={`${headerstyles.widget_username_sidenav} text-capitalize mb-0`}>
                                                    {userloggedinfobjcontext.userinfo.name}
                                                </p>
                                            </div>
                                            <div className={headerstyles.header_image_container}>
                                                {userloggedinfobjcontext.currentinstinfo.instlogo != '' ? (
                                                    <img
                                                        src={imagebaselink + userloggedinfobjcontext.currentinstinfo.instlogo}
                                                        style={{ objectFit: 'contain' }}
                                                        alt="Store Logo"
                                                    />
                                                ) : (
                                                    <img src={noimage} alt="Store Logo" />
                                                )}
                                            </div>
                                        </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => routedispatchercontext('/dashboard/institute/generalsettings')}>
                                            <span className="d-flex font_13 font-weight-500 text-black text-secondaryhover align-items-center">
                                                <i className={langdetect == 'en' ? 'fa fa-cog mr-2' : 'fa fa-cog mr-0 ml-2'} style={{ opacity: 0.3 }}></i>
                                                {lang.sidenav_generalsettings}
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => LogoutMutation.mutate()}>
                                            <span className="d-flex font_13 font-weight-500 text-black text-secondaryhover align-items-center">
                                                <i className={langdetect == 'en' ? 'fa fa-sign-out-alt mr-2' : 'fa fa-sign-out-alt mr-0 ml-2'} style={{ opacity: 0.3 }}></i>
                                                {lang.logout}
                                            </span>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </li>

                            <div className={headerstyles.header_divider} />
                            <li className={langdetect == 'en' ? '' : 'dropdown-container-translated'}>{languageToggle}</li>
                        </ul>
                    </div>
                </div>
                {motivationBanner}
            </div>

            {/* Mobile header */}
            <div className={`${headerstyles.header_container} d-flex d-lg-none`}>
                <div className={headerstyles.header_inner}>
                    <div className={headerstyles.header_left}>
                        <button
                            type="button"
                            className={headerstyles.hamburger}
                            id="burgericon"
                            onClick={() => {
                                var element = document.getElementById('sidenavContainer');
                                element.classList.add(sidenavstyles.sidebar_mobile_open);
                            }}
                        >
                            {langdetect == 'en' ? <CgMenuLeftAlt /> : <CgMenuRightAlt />}
                        </button>
                        {userloggedinfobjcontext.userinfo.currentinstactive != '621fbdd302691' && (
                            <div
                                className={`${headerstyles.header_container__logo} cursor-pointer`}
                                onClick={() => history.push('/dashboard/institute')}
                            >
                                <img src={tabexlogo} alt="Tabex" />
                            </div>
                        )}
                    </div>
                    <div className={headerstyles.header_right}>
                        <div className={headerstyles.header_menu} style={{ gap: 8 }}>
                            <div className={langdetect == 'en' ? '' : 'dropdown-container-translated'}>{languageToggle}</div>
                        </div>
                    </div>
                </div>
                {motivationBanner}
            </div>
        </div>
    );
};

export default Header;
